<div class="flex flex-col items-center justify-center gap-6 public-container">
  @if (passwordCodeNotification) {
	  @if (passwordCodeNotification === passwordCodeNotificationValues.code_resent) {
		  <pin-notification type="success" class="w-full">
			  We have sent you a new verification code.
		  </pin-notification>
	  } @else {
	    <pin-notification type="alert" class="w-full">
	      @switch (passwordCodeNotification) {
	        @case (passwordCodeNotificationValues.code_expired) {
	          The code you entered has expired. Try requesting a new code.
	        }
	        @case (passwordCodeNotificationValues.code_incorrect) {
	          The code you entered was incorrect. Try re-entering your code or request a new code.
	        }
	        @case (passwordCodeNotificationValues.too_many_tries) {
	          Too many attempts. Please try again later.
	        }
            @case (passwordCodeNotificationValues.try_again_later) {
              This page is currently unavailable. Please try again later.
            }
	      }
	    </pin-notification>
	  }
  }

  <form class="flex flex-col items-center justify-center gap-10" [formGroup]="verifyForm" (ngSubmit)="changePassword()">
    <div class="flex flex-col justify-center gap-4 w-full">
      <div class="flex flex-col flex-wrap justify-center gap-2">
        <div class="dcp-h1">
          {{ isPasswordlessSetup ? 'Verify your account' : 'Enter Verification Code' }}
        </div>
        <p class="dcp-body" id="code.verification.subtitle">
          If the information you provided is valid, you will receive an email with a verification code.
        </p>
      </div>

      <div class="flex flex-col justify-center">
        <div class="flex">
          <mat-form-field class="w-full" appearance="outline" id="user.credentials.code">
            <mat-label>Enter your code</mat-label>

            <input matInput placeholder="Enter your code" type="text" formControlName="code" id="code"
                   (keyup)="verifyForm.controls['code'].markAsTouched()" pinAlphanumericCode pinAutoFocus>
            @if (verifyForm.controls['code'].hasError('required')) {
              <mat-error id="code.required">
                This field is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>

        <pin-button buttonStyle="icon-link" buttonType="button" iconName="autorenew" (buttonClick)="resendValidationCode()" (keydown)="handleEnterKeyDown($event)"
                    id="request.code" [iconCustomClass]="resendingCode ? 'fa-spin' : ''" [isDisabled]="resendingCode || resendCountdown > 0">
	        Request a new code
        </pin-button>
        @if (resendCountdown > 0) {
          <p class="dcp-body-small gray-color" id="request.code.countdown" aria-live="polite">
            You can request a new code in {{ resendCountdown }}s
          </p>
        }
      </div>
    </div>

    <div class="flex flex-col justify-center gap-2 w-full">
      <div class="dcp-h1" id="code.verification.pass.title">
        {{ isPasswordlessSetup ? 'Reset Password' : 'Create New Password' }}
      </div>
      @if (isPasswordlessSetup) {
        <p class="dcp-body" id="password.reset.explanation">
          As part of recent security updates, you must create a new password to proceed.
        </p>
      }
      <mat-form-field appearance="outline" id="user.credentials.password">
        <mat-label>Create your new password</mat-label>

        <pin-password-input formControlName="password" (passwordFocus)="passwordTooltip.onPasswordFocus($event)" (passwordBlur)="onPasswordBlur()" [allowPaste]="false"></pin-password-input>

        @if (verifyForm.controls['password'].hasError('required')) {
          <mat-error id="password.required" i18n="@@password.required">
            This field is <strong>required</strong>
          </mat-error>
        }

        @if (verifyForm.controls['password'].hasError('pattern')) {
          <mat-error>Password does not meet the requirements</mat-error>
        }
      </mat-form-field>

      <pin-password-info [positionLeft]='passwordTooltip.passwordTooltipLeft'
                         [positionTop]='passwordTooltip.passwordTooltipTop'
                         [show]='passwordTooltip.showPasswordTooltip'
                         (mouseenter)="passwordTooltip.isPasswordTooltipFocused=true"
                         (mouseleave)="passwordTooltip.isPasswordTooltipFocused=false"
                         customClass="registration-password-helper">
      </pin-password-info>

      <mat-form-field appearance="outline" id="user.credentials.verify.password" class="w-full">
        <mat-label>Verify new password</mat-label>

        <pin-password-input formControlName="passwordConfirmation" [allowPaste]="false"></pin-password-input>

        @if (verifyForm.controls['passwordConfirmation'].hasError('required')) {
          <mat-error id="verify.password.invalid" i18n="@@verify.password.required">
            This field is <strong>required</strong>
          </mat-error>
        }

        @if (verifyForm.controls['passwordConfirmation'].hasError('pwdDoesNotMatch')) {
          <mat-error id="verify.password.match" i18n="@@verify.password.match">
            Verify Password does not match the Password entered
          </mat-error>
        }
      </mat-form-field>

      <div class="flex flex-col items-center justify-center gap-4 w-full mt-2">
        <pin-button buttonStyle="filled" class="w-full" buttonId="create-new-password-button" [isDisabled]="changingPassword">{{ isPasswordlessSetup ? 'VERIFY AND RESET PASSWORD' : 'CREATE NEW PASSWORD' }}</pin-button>
         <pin-button buttonStyle="icon-link" buttonId="create-password-back-to-login-button" [buttonType]="buttonType.DEFAULT" iconName="arrow_back" redirectUrl="/login">
          Back to login
        </pin-button>
      </div>
    </div>
  </form>
</div>
@if (changingPassword) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
